import { LocationSearchingOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { getIsTrackingMapEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const TrackingTab = () => {
  const display = useSelector(getIsTrackingMapEnabled)
  if (!display) {
    return null
  }

  return <NavbarItem name='Tracking' href={Routes.tracking} icon={<LocationSearchingOutlined />} />
}

export default TrackingTab

